<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>

        <!-- Group-gated to the BillingAdmin Cognito group (Admin retains access). The v-show
             mirrors the BillingAdmin gating used by the VendorDashboard host. The whole cost
             function (approve, set-status, line editing) is restricted to BillingAdmin. -->
        <div v-show="BillingAdmin || AdminUser" class="track-shipment update-user">
            <div class="confirm-svg">
                <h2>Trip Cost Approval</h2>
            </div>
            <p class="cp-subtitle">
                Review dispatched trips with an open cost status and approve their vendor cost.
            </p>

            <!-- Open-trips list (Task 15 fills in the list query, filters, and selection). -->
            <trip-cost-table
                :key="refreshKey"
                :jwtToken="jwtToken"
                @selectTrip="selectTrip($event)"
            />
        </div>
    </div>
</div>

<!-- Per-trip cost editor (Tasks 16-19 fill in population, line math, approval, and status rules). -->
<trip-cost-editor
    v-if="selectedTrip"
    :key="selectedTrip"
    :tripSheetId="selectedTrip"
    :jwtToken="jwtToken"
    @closeTripCostEditor="closeTripCostEditor($event)"
/>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import { Auth, API } from 'aws-amplify';
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import TripCostTable from './TripCostTable.vue';
import TripCostEditor from './TripCostEditor.vue';

export default {
    components: {
        SignedInUserInfo,
        AlertUser,
        TripCostTable,
        TripCostEditor,
    },
    data() {
        return {
            user: {},
            userData: {},
            loadingUser: false,
            jwtToken: null,
            AdminUser: false,
            BillingAdmin: false,
            selectedTrip: null,
            refreshKey: 0,
            toggleAlertBox: false,
            alertMessage: null,
        };
    },
    methods: {
        selectTrip(tripSheetId) {
            this.selectedTrip = tripSheetId;
        },
        closeTripCostEditor() {
            this.selectedTrip = null;
            // Reload the open-trips list so an approved/ignored/abandoned trip drops off.
            this.refreshKey++;
        },
        closeAlertBox(toggleAlertBox) {
            this.toggleAlertBox = toggleAlertBox;
        },
        async GetUserGraphQL() {
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                            userName
                            accountNo
                            fullname
                            userEmail
                        }
                    }`,
                    variables: {
                        userName: this.user.username,
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information";
            } finally {
                this.loadingUser = false;
            }
        },
    },
    mounted() {
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            const groups = this.user.signInUserSession.idToken.payload['cognito:groups'];
            if (groups) {
                groups.forEach((group) => {
                    if (group == 'Admin') this.AdminUser = true;
                    if (group == 'BillingAdmin') this.BillingAdmin = true;
                });
            }

            // Restrict the entire cost function to the BillingAdmin Cognito group (Admin retains
            // access). Mirrors the BillingAdmin gating used by the VendorDashboard host and the
            // /TripCostDashboard router guard.
            if (!this.BillingAdmin && !this.AdminUser) {
                alert("Access denied to trip cost dashboard");
                this.$router.push('/ShipmentDashboard');
            }
        }).catch(error => {
            if (error) {
                this.$router.push('Login');
                Auth.signOut({ global: false });
            }
        });
    },
};
</script>

<style scoped>
html {
    background-color: #f3f3f3;
}

.main-container {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container {
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
}

.track-shipment {
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.confirm-svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-bottom: 5px;
    align-self: flex-start;
}

.confirm-svg h2 {
    margin: 0;
}

.cp-subtitle {
    align-self: flex-start;
    color: #6a6a6a;
    margin: 0 0 10px 0;
}

@media only screen and (max-width: 1300px) {
    .inner-container {
        width: 85%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container {
        width: 95%;
    }
}
</style>
